module.exports = __webpack_public_path__ + "static/img/Aapple.ac639b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Aapple.png
// module id = nu8x
// module chunks = 1